import {
  PermissionTableModule,
  PermissionTableOperation,
  PermissionsTableRow,
} from '@modules/users/types';
import { getPermissionTableOperation } from '@modules/users/utils';
import { UserType, UserTypeWithPermissions } from 'generated/graphql';
import { PERMISSION_RESOURCE_TO_MODULE_MAP } from '../constants';

const initializeRoleOperations = (): Pick<
  PermissionsTableRow,
  'adminOperation' | 'editorOperation' | 'memberOperation' | 'viewerOperation'
> => ({
  adminOperation: PermissionTableOperation.None,
  editorOperation: PermissionTableOperation.None,
  memberOperation: PermissionTableOperation.None,
  viewerOperation: PermissionTableOperation.None,
});

export const getPermissionsRows = (
  permissionsData: UserTypeWithPermissions[] | undefined,
): PermissionsTableRow[] => {
  if (!permissionsData) {
    return [];
  }

  const permissionsByRolesMap = new Map<
    PermissionsTableRow['module'],
    ReturnType<typeof initializeRoleOperations>
  >();

  permissionsData.forEach(({ type, permissions }) => {
    permissions?.forEach(({ resource, operation }) => {
      const permissionModules = PERMISSION_RESOURCE_TO_MODULE_MAP[resource];
      permissionModules.forEach((module) => {
        const roles =
          permissionsByRolesMap.get(module) ?? initializeRoleOperations();

        switch (type) {
          case UserType.Manager:
            roles.adminOperation = getPermissionTableOperation(operation);
            break;
          case UserType.Editor:
            roles.editorOperation = getPermissionTableOperation(operation);
            break;
          case UserType.Member:
            roles.memberOperation = getPermissionTableOperation(operation);
            break;
          case UserType.Viewer:
            roles.viewerOperation = getPermissionTableOperation(operation);
        }

        permissionsByRolesMap.set(module, roles);
      });
    });
  });

  permissionsByRolesMap.set(PermissionTableModule.QueryData, {
    adminOperation: PermissionTableOperation.Edit,
    editorOperation: PermissionTableOperation.Edit,
    memberOperation: PermissionTableOperation.Edit,
    viewerOperation: PermissionTableOperation.Edit,
  });

  return Array.from(permissionsByRolesMap.entries()).map(([module, roles]) => ({
    module,
    ...roles,
  }));
};
